<template>
  <div class="flipchart">
    <!--{{elementWidth}}-->
    <h1 class="title">Consonants</h1>
    <Consonants :cols="cols" />
    <h1 class="title">Vowels</h1>
    <Vowels :cols="cols" />
  </div>
</template>

<script>
import Consonants from './Consonants.vue'
import Vowels from './Vowels.vue'

const _ = require('lodash');

export default {
  name: 'FlipChart',
  components: {
    Consonants,
    Vowels
  },
  
  data: function() {
    return {
      'elementWidth': null,
      'cols': 0,
    }
  },
  methods: {

  },
  mounted: function() {
    var self = this; // every day we stray further from god...
    this.elementWidth = this.$el.clientWidth;

    // determine the number of columns to optimally display
    // given the current element width
    var _numCols = 2;

    var _padding = 2 * 27; // minimum padding in px on each side of the element

    //TODO:  convert this from a px calc to em for usable space.  CSS refactor needed.
    if(this.elementWidth / ((190 + _padding) * 7) >= 1.0) {
      _numCols = 7;
    } else if(this.elementWidth / ((190 + _padding) * 6) >= 1.0) {
      _numCols = 6;
    } else if(this.elementWidth / ((190 + _padding) * 5) >= 1.0) {
      _numCols = 5;
    } else if(this.elementWidth / ((190 + _padding) * 4) >= 1.0) {
      _numCols = 4;
    } else if(this.elementWidth / ((190 + _padding) * 3) >= 1.0) {
      _numCols = 3;
    } else {
      _numCols = 2;
    }

    this.cols = _numCols; // set it initially so everything following is cool

    var debouncedInitCall = _.debounce(function() {
      //console.log("Debounced setCols:  ", _numCols);
      this.cols = _numCols;
    }, 500);

    debouncedInitCall();

    window.onresize = function() {
      self.elementWidth = self.$el.clientWidth;
      
      // determine the number of columns to optimally display
      // given the current element width
      var numCols = 2;
      var padding = 2 * 27; // minimum padding in px on each side of the element

      //TODO:  convert this from a px calc to em for usable space.  CSS refactor needed.
      if(self.elementWidth / ((190 + padding) * 7) >= 1.0) {
        numCols = 7;
      } else if(self.elementWidth / ((190 + padding) * 6) >= 1.0) {
        numCols = 6;
      } else if(self.elementWidth / ((190 + padding) * 5) >= 1.0) {
        numCols = 5;
      } else if(self.elementWidth / ((190 + padding) * 4) >= 1.0) {
        numCols = 4;
      } else if(self.elementWidth / ((190 + padding) * 3) >= 1.0) {
        numCols = 3;
      } else {
        numCols = 2;
      }
      // console.log(typeof self.cols);
      // console.log(typeof numCols);
      // console.log(numCols == self.cols);
      
      var debouncedCall = _.debounce(function() {
        //console.log("Debounced setCols:  ", numCols);
        self.cols = numCols;
      }, 500);

      debouncedCall();
      
    };
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

  .flipchart {
    background-color: #0a696f;
    padding-top: 10px;
  }

  h1.title {
    color: #ffde59;
    text-align: center;
  }

  .flipchart  h3 {
    margin: 40px 0 0;
  }
  .flipchart  ul {
    list-style-type: none;
    padding: 0;
  }
  .flipchart  li {
    display: inline-block;
    margin: 0 10px;
  }
  .flipchart  a {
    color: #42b983;
  }
</style>
